import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import backgroundStyles from './style/background.module.css';
import sizeStyles from './style/size.module.css';

const whitespaceBackgrounds = Object.keys(backgroundStyles);
const whitespaceSizes = Object.keys(sizeStyles);

const cx = classNames.bind({ ...backgroundStyles, ...sizeStyles });

export default function Whitespace({ backgroundColor, size, sizeM, sizeS }) {
  const sizeBreakPointM = `breakPointM-padding-${sizeM}`;
  const sizeBreakPointS = `breakPointS-padding-${sizeS}`;
  const whitespaceClassName = cx(
    'whitespace',
    backgroundColor,
    size,
    sizeBreakPointM,
    sizeBreakPointS
  );

  return <div className={whitespaceClassName} />;
}

Whitespace.propTypes = {
  backgroundColor: PropTypes.oneOf(whitespaceBackgrounds),
  size: PropTypes.oneOf(whitespaceSizes),
  sizeM: PropTypes.oneOf(whitespaceSizes),
  sizeS: PropTypes.oneOf(whitespaceSizes),
};

Whitespace.defaultProps = {
  backgroundColor: 'white',
  size: 'm',
  sizeM: 'm',
  sizeS: 'm',
};



// WEBPACK FOOTER //
// ./src/components/commons/Whitespace/index.js